import React from 'react'
import { TableRow, TableCell } from '@mui/material'
import useStyles from '../styles'

const SpacerRow: React.FC<{ cellCount: number }> = ({ cellCount }) => {
  const arrayToMap = new Array(cellCount)
  const { classes, cx } = useStyles({})

  return (
    <TableRow className={cx(classes.lastRow, classes.spacer)} key={'spacer-row'}>
      {arrayToMap.map(index => (
        <TableCell key={`spacer-${index}`}></TableCell>
      ))}
    </TableRow>
  )
}
export default SpacerRow
